import { render } from "./TkAttachmentsPanel.vue?vue&type=template&id=1ed85826&scoped=true"
import script from "./TkAttachmentsPanel.vue?vue&type=script&lang=js"
export * from "./TkAttachmentsPanel.vue?vue&type=script&lang=js"

import "./TkAttachmentsPanel.vue?vue&type=style&index=0&id=1ed85826&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed85826"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBtn});
